import projectsYaml from 'data/projects.yaml';

export class ProjectsData {
    categories: ProjectCategory[] = []
    projects: ProjectInfo[] = []
}

export class ProjectCategory {
    tag!: string;
    title!: string;
    projects: ProjectInfo[] = []
}

export class ProjectInfo {
    tag!: string;
    title!: string;
    description!: string;
    category!: string;
    icon?: string;
    iconUrl?: string;
    icons?: string[];
    iconsUrls?: string[];

}

function getProjectsData(): ProjectsData {
    let pd = new ProjectsData();

    for (let ycat of projectsYaml.categories) {
        let cat = new ProjectCategory();
        cat.tag = ycat.tag;
        cat.title = ycat.title;
        pd.categories.push(cat);
    }

    for (let yp of projectsYaml.projects) {
        let proj = new ProjectInfo();
        proj.tag = yp.tag;
        proj.title = yp.title;
        proj.description = yp.description;
        

        if (yp.icon) {
            proj.icon = yp.icon;
            proj.iconUrl = `/images/${proj.icon}`;
        }

        if (yp.icons) {
            proj.icons = [];
            proj.iconsUrls = [];
            for (let yi of yp.icons) {
                proj.icons.push(yi);
                proj.iconsUrls.push(`/images/${yi}`);
            }
        }

        if (!yp.category)
            throw new Error(`category is missing: ${proj.tag}`);
        proj.category = yp.category;

        let category = pd.categories.find(item => item.tag === proj.category);
        if (!category)
            throw new Error(`invalid category: ${proj.tag}`);

        category.projects.push(proj);
        
        pd.projects.push(proj);
    }
    //let data = new WipData(yaml.wip);
    //console.log(data);
    return pd;
}

export const projects_ = getProjectsData();

//export projec
